import { observable, action } from 'mobx'
import { message, Modal } from 'hljd'
import Api from '@api/sa_li/contact'
import HomeApi from '@api/xiu_yan/homeApi'
import { getSessionMerchantInfo } from '@merchant-backend/util'

class Store {
  @observable msgBoxModalVisible = false
  baseData = {}

  @action
  openMsgBoxModal = async info => {
    // 留言先校验24小时前是否预约过
    const { data } = await HomeApi.isAppointment({
      to_type: info.to_type == 'operator' ? 2 : 1
    })

    if (data) {
      Modal.error({
        title: '预约失败',
        content: '24小时内只能预约一次回电,请勿频繁预约哦'
      })
    } else {
      this.baseData = info
      this.msgBoxModalVisible = true
    }
  }

  @action
  closeMsgBoxModal = () => {
    this.msgBoxModalVisible = false
  }

  save = async ({ content, phone }) => {
    const { to_id, to_type } = this.baseData

    const params = {
      system_job_info: {
        extend_info: {
          content,
          phone
        },
        merchant_id: getSessionMerchantInfo().id,
        to_id,
        to_type: to_type == 'operator' ? 2 : 1
      }
    }

    const { success } = await Api.leaveMsg(params)

    if (success) {
      if (to_type == 'operator') {
        message.success('留言成功！')
      } else {
        Modal.success({
          title: '留言成功',
          content: '工作人员将尽快与您联系'
        })
      }

      this.closeMsgBoxModal()
    }
  }
}

export default Store
